import { useResource } from '@townsquare/router/useResource';

import { dashboardExperienceResource } from '../resources/DashboardExperienceResource';

export const useDashboardExperienceStatus = (): {
	isOptedIn: boolean;
	isOptedInToAi: boolean;
	loading?: boolean;
} => {
	const { data, loading, error } = useResource(dashboardExperienceResource);
	return !loading && !error && data
		? { isOptedIn: data.isOptedIn, isOptedInToAi: data.isOptedInToAi, loading }
		: { isOptedIn: false, isOptedInToAi: false, loading };
};
